export enum FileType {
    WORKFLOW_DATA = 'workflow-data'
}
